import { RESET } from '../actionTypes';
import { installerProfileActions } from '../reducer';

export default () => installerProfileActions[RESET]();
